import React from "react";

// Define the component's props to accept standard SVG attributes
interface LockIconProps extends React.SVGProps<SVGSVGElement> {}

const LockIcon: React.FC<LockIconProps> = (props) => {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Lock Icon"
      {...props} // Pass through any other props like className, onClick, etc.
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33337 3.33329C6.33337 1.86053 7.67652 0.666626 9.33337 0.666626C10.9902 0.666626 12.3334 1.86053 12.3334 3.33329V5.99996H10.8334V3.33329C10.8334 2.59691 10.1618 1.99996 9.33337 1.99996C8.50495 1.99996 7.83337 2.59691 7.83337 3.33329V5.99996H8.33337C9.06975 5.99996 9.66671 6.59691 9.66671 7.33329V13.3333C9.66671 14.0697 9.06975 14.6666 8.33337 14.6666H1.66671C0.930328 14.6666 0.333374 14.0697 0.333374 13.3333V7.33329C0.333374 6.59691 0.930328 5.99996 1.66671 5.99996H6.33337V3.33329Z"
        fill="#808080" // Use currentColor to inherit color from CSS
      />
    </svg>
  );
};

export default LockIcon;
